var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"flex items-center justify-center w-8 h-8 rounded-full cursor-pointer",class:[_vm.highlightClassess, _vm.custom],on:{"click":_vm.toggleHighlight}},_vm.listeners),[_c('base-icon',{attrs:{"name":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }